import axios from 'axios';
import store from '@/store'; // adjust the path based on your project structure
import router from '@/router';
const instance = axios.create({
  baseURL: 'https://musafir.customs.ly/api/',
  // baseURL: 'http://localhost:5041/',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});


// Request interceptor — show loader
instance.interceptors.request.use(config => {
  store.dispatch('startLoading');
  return config;
}, error => {
  store.dispatch('stopLoading');
  return Promise.reject(error);
});

// Response interceptor — hide loader
instance.interceptors.response.use(response => {
  store.dispatch('stopLoading');
  return response;
}, error => {
  store.dispatch('stopLoading');
   if (error.response && error.response.status === 401) {
      // Token might be expired or invalid
      handleExpiredToken();
   }
  return Promise.reject(error);
});

function handleExpiredToken() {
  // Redirect to login
  const alert = `<div class='alert alert-warning alert-dismissible temp-alert'>
      انتهت صلاحية الجلسة ، يرجى تسجيل الدخول
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>`
    $("<div>", { class: "temp-alert-container", id: 'session-expired' })
    .html(alert)
    .appendTo("body")
    .slideDown(300);
  setTimeout(function () {
    $("#session-expired").slideUp(500, function () {
      $(this).remove();
    });
  }, 3000);
  router.push("/admin/login");
}



export default instance;